import { Chip } from "@mui/material";
import ReceiptLongRoundedIcon from "@mui/icons-material/ReceiptLongRounded";
import DeleteOutlineRoundedIcon from "@mui/icons-material/DeleteOutlineRounded";
import HistoryRoundedIcon from "@mui/icons-material/HistoryRounded";
import { formatDate, parsePaymentDate } from "../../utils/date";
import { ActionIconButton } from "../../components/datatable/DataGridActions";
import { getPaymentGroupKey } from "./paymentUtils";

const statusColorMap = (status) => {
  const key = String(status || "").toLowerCase();
  if (
    [
      "captured",
      "success",
      "completed",
      "paid",
      "authorized",
      "authorized",
    ].includes(key)
  )
    return "success";
  if (["created", "authenticated", "pending"].includes(key)) return "warning";
  if (["failed", "cancelled", "refunded", "error"].includes(key))
    return "error";
  return "default";
};

const columnsData = [
  {
    field: "transaction_id",
    headerName: "Transaction ID",
    flex: 1,
    minWidth: 120,
  },
  {
    field: "name",
    headerName: "Kid Name",
    flex: 1,
    minWidth: 100,
  },
  {
    field: "full_name",
    headerName: "Mentor Name",
    flex: 1,
    minWidth: 120,
    renderCell: (params) => {
      return (
        <>
          {!params.row.mentor_id && !params.row.mentor_name
            ? "Anonymous"
            : params.row.full_name || params.row.mentor_name}
        </>
      );
    },
  },
  {
    field: "amount",
    headerName: "Amount",
    flex: 1,
    minWidth: 90,
    renderCell: (params) => <div>₹{params.row.amount}</div>,
  },
  {
    field: "status",
    headerName: "Status",
    flex: 1,
    minWidth: 100,
    renderCell: (params) => (
      <Chip
        size="small"
        label={params.row.status || "N/A"}
        variant="outlined"
        color={statusColorMap(params.row.status)}
      />
    ),
  },
  {
    field: "payment_date",
    headerName: "Payment Date",
    flex: 1,
    minWidth: 120,
    valueGetter: (params) => parsePaymentDate(params.row.payment_date),
    renderCell: (params) => <div>{formatDate(params.row.payment_date)}</div>,
    sortComparator: (v1, v2) => v2 - v1,
    sortable: true,
  },
];

let actionHeader = (handleDelete, onHistoy, paymentCountByKey) => {
  return [
    {
      field: "action",
      headerName: "Action",
      minWidth: 132,
      maxWidth: 160,
      sortable: false,
      align: "center",
      headerAlign: "center",
      renderCell: (params) => (
        <div className="cellAction cellAction--icons">
          {params.row.certificate_url && (
            <ActionIconButton
              title="View receipt"
              href={params.row.certificate_url}
              download
            >
              <ReceiptLongRoundedIcon fontSize="small" />
            </ActionIconButton>
          )}
          <ActionIconButton
            title="Delete payment"
            onClick={() => handleDelete(params.row.id)}
            color="error"
          >
            <DeleteOutlineRoundedIcon fontSize="small" />
          </ActionIconButton>
          {(paymentCountByKey[getPaymentGroupKey(params.row)] || 0) > 1 && (
            <ActionIconButton
              title="Payment history"
              onClick={() => onHistoy(params.row)}
            >
              <HistoryRoundedIcon fontSize="small" />
            </ActionIconButton>
          )}
        </div>
      ),
    },
  ];
};

/** Same actions as main grid minus “history” (used in payment history modal). */
export const paymentHistoryActionColumn = (handleDelete) => [
  {
    field: "action",
    headerName: "Action",
    minWidth: 132,
    maxWidth: 160,
    sortable: false,
    align: "center",
    headerAlign: "center",
    renderCell: (params) => (
      <div className="cellAction cellAction--icons">
        {params.row.certificate_url && (
          <ActionIconButton
            title="View receipt"
            href={params.row.certificate_url}
            download
          >
            <ReceiptLongRoundedIcon fontSize="small" />
          </ActionIconButton>
        )}
        <ActionIconButton
          title="Delete payment"
          onClick={() => handleDelete(params.row.id)}
          color="error"
        >
          <DeleteOutlineRoundedIcon fontSize="small" />
        </ActionIconButton>
      </div>
    ),
  },
];

const columnHeader = {
  columnsData,
  actionHeader,
};

export default columnHeader;
